<template>
  <div class="draw">
    <div class="card-container">
      <div class="card-scroll">
        <div class="card-list card-list-right">
          <div class="card-ul" v-for="(item, index) in 3" :key="index">
            <div
              class="card-item"
              v-for="(item1, index1) in foodTypeList"
              :key="index1"
            >
              <img
                class="card-card opacity-card-30 card-sides-shadow"
                :src="item1.image"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-scroll">
        <div class="card-list card-list-left">
          <div class="card-ul" v-for="(item, index) in 3" :key="index">
            <div
              class="card-item"
              v-for="(item1, index1) in foodTypeList"
              :key="index1"
            >
              <img class="card-card card-shadow" :src="item1.image" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="card-scroll">
        <div class="card-list card-list-right">
          <div class="card-ul" v-for="(item, index) in 3" :key="index">
            <div
              class="card-item"
              v-for="(item1, index1) in foodTypeList"
              :key="index1"
            >
              <img
                class="card-card opacity-card-50"
                :src="item1.image"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      foodTypeList: [
        {
          name: '外卖',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/34e4dbef483c9dfd53a5ba1b52269746.png'
        },
        {
          name: '自制',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6c5c7ac13b35c2130719f07673fc536f.png'
        },
        {
          name: '零食',
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3e5d5e305a9629912f19fb2a1a07f018.png'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.draw {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1000px;

  .card-container {
    width: 100%;

    transform: translate(0%, -15px) rotate(-15deg);

    .card-scroll {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      .card-list {
        display: inline-flex;
        flex-wrap: nowrap;
        align-items: center;

        .card-ul {
          transition: all 0s ease;
          display: inline-flex;
          flex-wrap: nowrap;
          align-items: center;
        }

        .card-item {
          flex: 0 0 140px;
          width: 140px;
          height: 180px;
          margin-right: 10px;

          .card-card {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      .card-list-left {
        .card-ul:first-child {
          animation: myMoveLeft1 60s linear infinite;
        }

        .card-ul:nth-child(2) {
          animation: myMoveLeft2 60s linear infinite;
        }

        .card-ul:last-child {
          animation: myMoveLeft3 60s linear infinite;
        }
      }

      .card-list-right {
        .card-ul:first-child {
          animation: myMoveRight1 60s linear infinite;
        }

        .card-ul:nth-child(2) {
          animation: myMoveRight2 60s linear infinite;
        }

        .card-ul:last-child {
          animation: myMoveRight3 60s linear infinite;
        }
      }
    }

    .card-scroll:last-child {
      margin-bottom: 0;
    }

    .opacity-card-50 {
      opacity: 0.5;
    }

    .opacity-card-30 {
      opacity: 0.3;
    }

    .card-shadow {
      box-shadow: 0px 11px 13px rgba(47, 132, 166, 0.5);
    }

    .card-sides-shadow {
      box-shadow: 0px 10px 12px rgba(47, 132, 166, 0.5);
    }
  }
}

@keyframes myMoveLeft1 {
  0% {
    transform: translate(300%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}

@keyframes myMoveLeft2 {
  0% {
    transform: translate(0%, 0px);
  }

  33.33% {
    transform: translate(-100%, 0px);
  }

  33.330001% {
    transform: translate(200%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}

@keyframes myMoveLeft3 {
  0% {
    transform: translate(0%, 0px);
  }

  66.66% {
    transform: translate(-200%, 0px);
  }

  66.660001% {
    transform: translate(100%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}

@keyframes myMoveRight1 {
  0% {
    transform: translate(0%, 0px);
  }

  66.66% {
    transform: translate(200%, 0px);
  }

  66.660001% {
    transform: translate(-100%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}

@keyframes myMoveRight2 {
  0% {
    transform: translate(0%, 0px);
  }

  33.33% {
    transform: translate(100%, 0px);
  }

  33.330001% {
    transform: translate(-200%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}

@keyframes myMoveRight3 {
  0% {
    transform: translate(0%, 0px);
  }

  0.000001% {
    transform: translate(-300%, 0px);
  }

  100% {
    transform: translate(0%, 0px);
  }
}
</style>
